module.exports = __webpack_public_path__ + "img/score_left.a8af8ceb.png";